import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Container, InputContainer, Input, SearchIcon, SelectContainer,
} from './styles'
import Select from '@components/inputs/select'
import colors from '@settings/styleSettings'

const ImportedExamsFilter = ({ onDateRangeChange, onSearch }) => {
  const options = [
    { value: 7, label: 'Últimos 7 dias' },
    { value: 30, label: 'Últimos 30 dias' },
    { value: 0, label: 'Todas as importações' },
  ]

  const [selectedOption, setSelectedOption] = useState(options[2])
  const [searchTerm, setSearchTerm] = useState('')

  const handleDateRangeChange = (option) => {
    setSelectedOption(option)
    onDateRangeChange(option)
  }

  const handleSearchClick = () => {
    onSearch(searchTerm)
  }

  return (
    <Container>
      <SelectContainer>
        <Select
          value={selectedOption}
          onChange={handleDateRangeChange}
          options={options}
          style={{
            height: '42px',
            option: {
              backgroundColor: colors.softGreen,
              color: colors.titleStrongBlack,
            },
          }}
        />
      </SelectContainer>
      <InputContainer>
        <Input
          placeholder="Digite parte do nome, CPF ou tipo de exames"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSearchClick()}
        />
        <SearchIcon
          className="material-icons-outlined"
          onClick={handleSearchClick}
        >
          search
        </SearchIcon>
      </InputContainer>
    </Container>
  )
}

ImportedExamsFilter.propTypes = {
  onDateRangeChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
}

export default ImportedExamsFilter
